// extracted by mini-css-extract-plugin
export default {"menuBlock":"mF-z","title":"nF-z","nav":"oF-z","flexCell":"pF-z","facetLink":"qF-z"};